export { default } from './DestacatEnllac';
